// extracted by mini-css-extract-plugin
export default {"root":"M9Kjk","avatar":"ePHq1","about":"lxX89","contact":"n+dqN","details":"IM1bY"};